module.exports = __webpack_public_path__ + "assets/media/evening.d8809a44.mp3";